import codeEditorService from '@/services/embeds/plugin/code.editor.service'
import executeService from '@/services/embeds/plugin/execute.service'
import languageSelectService from '@/services/embeds/plugin/language.select.service'
import outputEditorService from '@/services/embeds/plugin/output.editor.service'
import postToJdoodleService from '@/services/embeds/plugin/post.to.jdoodle.service'
import { useEmbedConfigureStore, type IEmbedLanguage } from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'

import { cloneDeep } from 'lodash-es'

/**
 * init get code feature
 */
const initGetCode = () => {
  useIdeStore().pymChild.onMessage('getCode', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getCode feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const script = codeEditorService.getScript()
      window.parent.postMessage({ script: script }, '*')
    }
  })
}
/**
 * init set code feature
 */
const initSetCode = () => {
  useIdeStore().pymChild.onMessage('setCode', (script: string = '') => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setCode feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      let processedScript = script
      try {
        processedScript = JSON.parse(script)
      } catch (e) {
        processedScript = script
      }
      codeEditorService.codeEditorSetProgram(processedScript)
      useIdeStore().pymChild?.sendHeight()
    }
  })
}
/**
 * init set clear code editor feature
 */
const initClearCodeEditor = () => {
  useIdeStore().pymChild.onMessage('clearCodeEditor', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The clearCodeEditor feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      codeEditorService.codeEditorSetProgram('')
      useIdeStore().pymChild?.sendHeight()
    }
  })
}
/**
 * init execute feature
 */
const initExecute = () => {
  useIdeStore().pymChild.onMessage('execute', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The execute feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      executeService.tryExecute()
    }
  })
}
/**
 * init stop execute feature
 */
const stopExecute = () => {
  useIdeStore().pymChild.onMessage('stopExecute', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The stopExecute feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      executeService.stopExecution()
    }
  })
}
/**
 * init get language list feature
 */
const initGetLanguageList = () => {
  useIdeStore().pymChild.onMessage('getLanguageList', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getLanguageList feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const languages = cloneDeep(
        useEmbedConfigureStore().getEmbedConfig?.languages.map((lang: IEmbedLanguage, index) => {
          return {
            id: index,
            language: lang.language
          }
        })
      )
      window.parent.postMessage({ languages: JSON.stringify(languages) }, '*')
    }
  })
}
/**
 * init set language feature
 */
const initSetLanguage = () => {
  useIdeStore().pymChild.onMessage('setLanguage', (id: string | number | null = null) => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setLanguage feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      if (id) {
        // check id is a number
        const index = typeof id === 'number' ? id : parseInt(id as any)
        const length = useEmbedConfigureStore().getEmbedConfig?.languages.length || 0
        if (typeof index !== 'number' || (index >= 0 && index < length)) {
          const selectedLanguage: IEmbedLanguage | null =
            cloneDeep(useEmbedConfigureStore().getEmbedConfig?.languages[index]) || null

          if (selectedLanguage) {
            useIdeStore().selectedLanguage = selectedLanguage
            languageSelectService.onSelectLanguageChange()
            useIdeStore().pymChild?.sendHeight()
          } else {
            const message = `invalide language id.`
            useIdeStore().setFeaturePermissionError(message)
          }
        } else {
          const message = `invalide language id.`
          useIdeStore().setFeaturePermissionError(message)
        }
      } else {
        const message = `id is missing in the setLanguage call.`
        useIdeStore().setFeaturePermissionError(message)
      }
    }
  })
}
/**
 * init get language version list feature
 */
const initGetVersionList = () => {
  useIdeStore().pymChild.onMessage('getVersionList', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getVersionList feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const versions = cloneDeep(
        useIdeStore().selectedLanguageVersionsList.map((version: string, index) => {
          return {
            id: index,
            version: version
          }
        })
      )
      window.parent.postMessage({ versions: JSON.stringify(versions) }, '*')
    }
  })
}
/**
 * init set version feature
 */
const initSetVersion = () => {
  useIdeStore().pymChild.onMessage('setVersion', (id: string | number | null = null) => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setVersion feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      if (id) {
        // check id is a number
        const index = typeof id === 'number' ? id : parseInt(id as any)
        const length = useIdeStore().selectedLanguageVersionsList.length || 0
        if (typeof index !== 'number' || (index >= 0 && index < length)) {
          const selectedVersion: string | null =
            cloneDeep(useIdeStore().selectedLanguageVersionsList[index]) || null

          if (selectedVersion) {
            useIdeStore().selectedVersion = id as number
            useIdeStore().pymChild?.sendHeight()
          } else {
            const message = `invalide version id.`
            useIdeStore().setFeaturePermissionError(message)
          }
        } else {
          const message = `invalide version id.`
          useIdeStore().setFeaturePermissionError(message)
        }
      } else {
        const message = `id is missing in the setVersion call.`
        useIdeStore().setFeaturePermissionError(message)
      }
    }
  })
}
/**
 * init get interactiveMode feature
 */
const initGetInteractiveMode = () => {
  useIdeStore().pymChild.onMessage('getInteractiveMode', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getInteractiveMode feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const interActiveMode = useIdeStore().interActiveMode
      window.parent.postMessage({ interactiveMode: JSON.stringify(interActiveMode) }, '*')
    }
  })
}
/**
 * init set interactiveMode feature
 */
const initSetInteractiveMode = () => {
  useIdeStore().pymChild.onMessage('setInteractiveMode', (status: boolean | string = 'false') => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setInteractiveMode feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      // check status is a boolean
      if (typeof status === 'boolean') {
        useIdeStore().interActiveMode = status as boolean
      } else if (status === 'true') {
        useIdeStore().interActiveMode = true
      } else if (status === 'false') {
        useIdeStore().interActiveMode = false
      } else {
        const message = `status should be a either 'true' or 'false'.`
        useIdeStore().setFeaturePermissionError(message)
      }
    }
  })
}
/**
 * init get interactiveMode feature
 */
const initGetStdinInput = () => {
  useIdeStore().pymChild.onMessage('getStdinInput', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getStdinInput feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const stdinArgs = useIdeStore().stdinArgs
      window.parent.postMessage({ stdinInput: JSON.stringify(stdinArgs) }, '*')
    }
  })
}

/**
 * init set stdin input feature
 */
const initSetStdinInput = () => {
  useIdeStore().pymChild.onMessage('setStdinInput', (stdIn: string = '') => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setStdinInput feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      useIdeStore().stdinArgs = stdIn
    }
  })
}
/**
 * init get interactiveMode feature
 */
const initGetInputArgst = () => {
  useIdeStore().pymChild.onMessage('getInputArgs', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getInputArgs feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const inputArgs = useIdeStore().inputArgs
      window.parent.postMessage({ inputArgs: JSON.stringify(inputArgs) }, '*')
    }
  })
}

/**
 * init set input input feature
 */
const initSetInputArgs = () => {
  useIdeStore().pymChild.onMessage('setInputArgs', (input: string = '') => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The setInputArgs feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      useIdeStore().inputArgs = input
    }
  })
}
/**
 * init get code feature
 */
const initGetOutput = () => {
  useIdeStore().pymChild.onMessage('getOutput', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The getOutput feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      const output = outputEditorService.getOutputEditorSession()
      window.parent.postMessage({ output: output }, '*')
    }
  })
}
/**
 * init set clear output editor feature
 */
const initClearOutputEditor = () => {
  useIdeStore().pymChild.onMessage('clearOutputEditor', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The clearOutputEditor feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      outputEditorService.outputEditorSetProgram('')
      useIdeStore().pymChild?.sendHeight()
    }
  })
}
/**
 * init execute feature
 */
const initPostToJdoodle = () => {
  useIdeStore().pymChild.onMessage('postToJDoodle', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The postToJDoodle feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      postToJdoodleService.postToJDoodle()
    }
  })
}
/**
 * init on code editor updated
 */
const initOnCodeEditorUpdate = () => {
  useIdeStore().pymChild.onMessage('enableOnCodeEditorUpdate', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The enableOnCodeEditorUpdate feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      if (!useIdeStore().codeEditor) return
      useIdeStore()
        .codeEditor.textInput.getElement()
        .addEventListener('keyup', () => {
          const script = codeEditorService.codeEditorGetProgram()
          window.parent.postMessage({ updatedScript: script }, '*')
        })
    }
  })
}
/**
 * init on code editor updated
 */
const initOnExecuteComplete = () => {
  useIdeStore().pymChild.onMessage('enableOnExecuteComplete', () => {
    if (useEmbedConfigureStore().getIsBasicType == true) {
      const message = `The enableOnExecuteComplete feature is not available Basic Embed.`
      useIdeStore().setFeaturePermissionError(message)
    } else {
      useIdeStore().setOnExecuteCompleteEnabled(true)
    }
  })
}

/**
 * when execute is completed send the output to the host app
 * @param result - The output
 */
const onExecuteCompleteEvent = (result: string = '') => {
  if (useIdeStore().onExecuteCompleteEnabled) {
    window.parent.postMessage({ result: result }, '*')
  }
}
/**
 * when the plugin is loaded set the functional features
 */
const initOnLoad = () => {
  if (useEmbedConfigureStore().getIsBasicType != true) {
    window.parent.postMessage({ onLoad: true }, '*')
  }
}
/**
 * when the plugin is loaded set the functional features
 */
const initFunctionalFeatures = () => {
  initGetCode()
  initSetCode()
  initClearCodeEditor()
  initExecute()
  stopExecute()
  initGetLanguageList()
  initSetLanguage()
  initGetVersionList()
  initSetVersion()
  initGetInteractiveMode()
  initSetInteractiveMode()
  initGetStdinInput()
  initSetStdinInput()
  initGetInputArgst()
  initSetInputArgs()
  initGetOutput()
  initClearOutputEditor()
  initPostToJdoodle()
  initOnCodeEditorUpdate()
  initOnExecuteComplete()
  initOnLoad()
}
export default {
  initFunctionalFeatures,
  onExecuteCompleteEvent
}
